export function removeItemFromList(
  list: Array<any>,
  item: string,
  propertyName?: string
) {
  let itemIndex = -1;

  if (!propertyName) {
    itemIndex = list.indexOf(item);
  } else {
    itemIndex = list.findIndex(listItem => {
      return listItem[propertyName] === item;
    });
  }
  list.splice(itemIndex, 1);
}

export function toStringArray(enumme) {
  return Object.keys(enumme).map(key => enumme[key]);
}
